import React from "react";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
function HowItWorks() {
  return (
    <>
      <div className="bg-white">
        <div className="abt_sc_1 mt-5 mb-15">
          <div className="container container_frnt">
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="top_img">
                  <img
                    alt=""
                    src={toAbsoluteUrl("/media/others/hwitwrk_img.jpg")}
                    className="img-fluid"
                  />
                </div>
              </div>
              <div className="col-md-8 mt-20 text-center">
                <h2 className="def_hdng_v1 mb-8 ml-auto mr-auto text-left">
                  HOW IT <span className="grbg_rndd">WORKS</span>
                </h2>
                <p className="def_p_v2 mb-8 text-left">
                  QRFID-GOLD is a cryptographic coin (token) which is backed by
                  real gold. Each gold bar is connected by a tamper-proof QRFID
                  tag to the blockchain and stored in a secure vault under a
                  process which is confirmed and notarized by a Swiss notary.
                  When you buy a token, you have actual ownership of the
                  corresponding gold clearly marked in the blockchain that lies
                  in the vault which you can view via a live Feed on the
                  website.
                </p>
                <img
                  alt=""
                  src={toAbsoluteUrl("/media/others/hwitwrk_img_2.png")}
                  className="img-fluid mt-5 mb-15 ml-auto mr-auto"
                />
                <p className="def_p_v2 mb-8 text-left">
                  QRFID-GOLD converts physical investment grade gold into a
                  digital store of value through the notarized emission process,
                  creating Tokens. Each token is based on a linear price
                  increase per emission. The starting Token is equal to 0.001g
                  of gold, and increases by 0.000000003725g per token emitted
                  thereafter. There are a total of 40 million Tokens able to be
                  emitted in this algorithm, resulting in the last token having
                  a worth of 0.15g of gold.
                </p>

                <img
                  alt=""
                  src={toAbsoluteUrl("/media/others/hwitwrk_img_3.png")}
                  className="img-fluid mt-8 mb-15 ml-auto mr-auto"
                />
                <p className="def_p_v2 mb-8 text-left">
                  The various steps for the emission process are as follows:
                </p>
                <ul className="abtinf_lst text-left">
                  <li>
                    <i className="fas fa-check-circle"></i> To begin with, 
                    Users buy investment grade gold from a reputable 
                    gold dealer registered under German and Swiss 
                    financial regulatory authorities.
                  </li>
                  <li>
                    <i className="fas fa-check-circle"></i> This gold is 
                    then brought to the secure vault where it is connected 
                    using a tamper-proof QRFID (Radio Frequency Identity) 
                    tag to the QRFID-GOLD Smart Contract, a process confirmed 
                    both by the vault management and Swiss notary.
                  </li>
                  <li>
                    <i className="fas fa-check-circle"></i> The QRFID-tagged 
                    gold is digitised in the form of Tokens by the QRFID-GOLD 
                    software.
                  </li>
                  <li>
                    <i className="fas fa-check-circle"></i> Tokens are then sent 
                    directly to the ERC-1400 compliant wallet as registered by 
                    the User in their profile.
                  </li>
                  <li>
                    <i className="fas fa-check-circle"></i> In the event that 
                    owners of their Tokens wish to remove their gold from the 
                    vault (only available to those with 100g or more) then their 
                    Tokens will be sent to the main Ethereum Burn Wallet under 
                    the supervision of a Swiss notary whilst simultaneously 
                    being removed from the Smart Contract blockchain. 
                    Users may need to undertake further Compliance checks by 
                    the Gold Dealer under whom the gold is stored in order to 
                    ensure that the legal owner of the Tokens is receiving the gold.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HowItWorks;
